// src/components/common/YouTubeEmbed.jsx
import React, { useRef, useEffect } from 'react';
import YouTube from 'react-youtube'; 

function YouTubeEmbed({ url, lessonId, onProgressUpdate, onFinish }) {
    const playerRef = useRef(null);
    const progressIntervalRef = useRef(null);

    const getYouTubeId = (url) => {
        const match = url?.match(/(?:youtu\.be\/|youtube\.com\/.*v=)([^"&?/ ]{11})/);
        return match ? match[1] : null;
    };
    
    const videoId = getYouTubeId(url);

    const startProgressTracking = () => {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = setInterval(() => {
            const player = playerRef.current;
            if (!player?.internalPlayer) return;

            Promise.all([
                player.internalPlayer.getCurrentTime(),
                player.internalPlayer.getDuration()
            ]).then(([currentTime,duration])=>{
                const percent=(currentTime/duration)*100;
                onProgressUpdate?.(lessonId,currentTime,duration,percent);
            });
        },5000);
    };

    const onPlayerStateChange=(event)=>{
        const S_PLAY=1, S_END=0, S_PAUSE=2;
        if(event.data===S_PLAY) startProgressTracking();
        if(event.data===S_PAUSE) clearInterval(progressIntervalRef.current);
        if(event.data===S_END){
            clearInterval(progressIntervalRef.current);
            onFinish?.();
        }
    };

    useEffect(()=>()=>clearInterval(progressIntervalRef.current),[]);

    const opts={
        width:"100%",
        height:"100%",
        playerVars:{ autoplay:0, rel:0, controls:1 }
    };

    return (
        <div className="w-full rounded-lg overflow-hidden bg-black 
            h-[60vh] md:h-[70vh] lg:h-[75vh] shadow-xl">
            
            {videoId ? (
                <YouTube
                    videoId={videoId}
                    opts={opts}
                    onReady={(e)=>playerRef.current=e.target}
                    onStateChange={onPlayerStateChange}
                />
            ) : (
                <div className="flex items-center justify-center text-white h-full">
                    ❌ Vídeo inválido
                </div>
            )}
        </div>
    );
}
export default YouTubeEmbed;
